
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sdk/point-of-sale/ios",
      function () {
        return require("private-next-pages/docs/sdk/point-of-sale/ios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sdk/point-of-sale/ios"])
      });
    }
  